import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { darken } from '@material-ui/core/styles';
import { Check } from '@material-ui/icons';
import { AD } from './adsAgentTokens';

// Popup content for a number that already used its free generation.

const BENEFITS = [
  'Generate more ads for your business',
  'Run them on Facebook & Instagram',
  'Get the leads straight on WhatsApp',
];

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: AD.fontFamily,
  },
  note: {
    margin: 0,
    fontSize: 13,
    lineHeight: 1.5,
    color: AD.textMuted,
  },
  benefits: {
    listStyle: 'none',
    margin: '12px 0 20px',
    padding: 0,
  },
  benefit: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '3px 0',
    fontSize: 13,
    color: AD.text,
  },
  check: {
    fontSize: 16,
    color: AD.cta,
    flexShrink: 0,
  },
  signup: {
    height: AD.controlHeight,
    borderRadius: AD.radiusLg,
    background: AD.cta,
    color: AD.onPrimary,
    textTransform: 'none',
    fontWeight: 700,
    fontSize: 13,
    '&:hover': { background: darken(AD.cta, 0.15) },
  },
  other: {
    marginTop: 4,
    textTransform: 'none',
    fontSize: 12.5,
    color: AD.textMuted,
  },
}));

const SignupInvite = (props: Props): React.ReactElement => {
  const { signupUrl, onUseAnotherNumber } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <p className={classes.note}>Create your free AiSensy account to keep going. You can:</p>

      <ul className={classes.benefits}>
        {BENEFITS.map((benefit) => (
          <li key={benefit} className={classes.benefit}>
            <Check className={classes.check} />
            {benefit}
          </li>
        ))}
      </ul>

      <Button
        className={classes.signup}
        component="a"
        href={signupUrl}
        target="_blank"
        rel="noopener noreferrer"
        fullWidth
      >
        Sign up to generate more
      </Button>
      <Button className={classes.other} onClick={onUseAnotherNumber}>
        Use a different number
      </Button>
    </div>
  );
};

interface Props {
  signupUrl: string;
  onUseAnotherNumber: () => void;
}

export default SignupInvite;
